import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Droit",
  icon: "⚖️",
  tagline: "Maîtrisez les fondamentaux du droit et devenez un professionnel du secteur juridique",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "12",
  description: "La filière Droit propose une formation complète dans les différentes branches du droit (civil, pénal, commercial, international). Notre programme forme des juristes compétents, capables d'exercer dans divers domaines du secteur juridique. Les étudiants développent des compétences en analyse juridique, rédaction et plaidoirie, tout en acquérant une solide culture juridique.",
  objectifs: [
    "Maîtriser les fondamentaux du droit civil, pénal et commercial",
    "Développer des compétences en analyse et raisonnement juridique",
    "Acquérir une expertise en droit des affaires",
    "Maîtriser les techniques de rédaction juridique",
    "Comprendre le droit international et comparé"
  ],
  programme: [
    {
      titre: "Licence 1 & 2",
      matieres: [
        "Introduction au droit",
        "Droit civil (personnes, famille, biens)",
        "Droit constitutionnel",
        "Droit administratif",
        "Droit pénal général",
        "Méthodologie juridique"
      ]
    },
    {
      titre: "Licence 3 & Master",
      matieres: [
        "Droit des affaires",
        "Droit commercial et des sociétés",
        "Droit du travail",
        "Droit international privé",
        "Procédure civile et pénale",
        "Droit fiscal"
      ]
    }
  ],
  debouches: [
    { titre: "Avocat", description: "Conseil et défense des clients" },
    { titre: "Juriste d'entreprise", description: "Conseil juridique en entreprise" },
    { titre: "Magistrat", description: "Juge ou procureur" },
    { titre: "Notaire", description: "Authentification d'actes juridiques" },
    { titre: "Huissier de justice", description: "Exécution des décisions de justice" },
    { titre: "Conseiller juridique", description: "Conseil et assistance juridique" }
  ],
  competences: [
    "Maîtrise du raisonnement et de l'argumentation juridique",
    "Capacité d'analyse et de synthèse de textes complexes",
    "Compétences en rédaction d'actes et de documents juridiques",
    "Connaissance approfondie du système juridique",
    "Capacité de plaidoirie et de négociation",
    "Éthique et déontologie professionnelle"
  ]
};

export default function Droit() {
  return <FiliereTemplate filiere={filiereData} />;
}